import urls from 'DjangoUrls';
import axios from 'axios';

let { DjangoUrls } = urls;

WikiSlideResource.$inject = ['$http'];

function WikiSlideResource($http) {
    return {
        create_slide,
        create_slides_from_media,
        delete_slide,
        link_to_location,
        unlink_location,
        update_slide,
        reorder_slides,
        attach_document,
        attach_link,
        delete_attachment,
        delete_attached_link,
    };

    function create_slide(sectionId, assistant= {}) {
        const url = DjangoUrls['api.v1:wiki_slide-create-slide']();
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: sectionId,
                ...assistant,
            }
        });
    }

    function create_slides_from_media(sectionId, mediaContentIdList, slideToReplaceId, assistant= {}) {
        const url = DjangoUrls['api.v1:wiki_slide-create-slides-from-media']();
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: sectionId,
                id_list: mediaContentIdList,
                slide_id: slideToReplaceId,
                ...assistant,
            }
        });
    }

    function delete_attachment(slideId, attachedDocumentId, assistant= {}) {
        const url = DjangoUrls['api.v1:wiki_slide-delete-attachment'](slideId);
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: attachedDocumentId,
                ...assistant
            }
        });
    }

    function delete_attached_link(slideId, attachedLinkId, assistant= {}) {
        const url = DjangoUrls['api.v1:wiki_slide-delete-attached-link'](slideId);
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: attachedLinkId,
                ...assistant,
            }
        });
    }

    function delete_slide(slideId, assistant= {}) {
        const url = DjangoUrls['api.v1:wiki_slide-detail'](slideId);
        return axios({
            method: 'delete',
            url: url,
            data:{
                ...assistant,
            }
        });
    }

    function link_to_location(id, location_id, assistant= {}) {
        const url = DjangoUrls[`api.v1:wiki_slide-link-to-location`](id);
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: location_id,
                ...assistant
            }
        });
    }

    function unlink_location(id, location_id, assistant= {}) {
        const url = DjangoUrls[`api.v1:wiki_slide-unlink-location`](id);
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: location_id,
                ...assistant,
            }
        });
    }

    function update_slide(slideId, updatedSlideData, assistant= {}) {
        const url = DjangoUrls[`api.v1:wiki_slide-update-slide`](slideId);
        const data = {
            caption: updatedSlideData.caption,
            description: updatedSlideData.description,
            media_content_id: updatedSlideData.media_content ? updatedSlideData.media_content.id : null,
            audio_caption_id: updatedSlideData.audio_caption ? updatedSlideData.audio_caption.id : null,
            audio_description_id: updatedSlideData.audio_description ? updatedSlideData.audio_description.id : null,
            ...assistant
        };

        return axios({
            method: 'POST',
            url: url,
            data
        });
    }

    function attach_document(id, mediaId, assistant= {}) {
        const url = DjangoUrls[`api.v1:wiki_slide-attach-document`](id);
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: mediaId,
                ...assistant,
            }
        });
    }

    function attach_link(id, urlToAdd, name, assistant= {}) {
        const url = DjangoUrls[`api.v1:wiki_slide-attach-link`](id);
        return axios({
            method: 'POST',
            url: url,
            data: {
                url: urlToAdd,
                name,
                ...assistant
            }
        });
    }

    function reorder_slides(sectionId, slidesOrderedIdList, assistant= {}) {
        const url = DjangoUrls[`api.v1:wiki_slide-reorder-slides`]();
        return axios({
            method: 'POST',
            url: url,
            data: {
                id: sectionId,
                id_list: slidesOrderedIdList,
                ...assistant
            }
        });
    }
}

export default WikiSlideResource;
